import { useCallback } from 'react';

import type { MappedFeature, StopType } from '@/types';

import useGetStationListData from '@/hooks/use-get-station-list-data';
import usePrepareGeojson from '@/hooks/use-prepare-geojson';

const useStopPositionData = () => {
  const { data } = useGetStationListData();

  const stationMapper = useCallback((station: StopType): MappedFeature | null => {
    const { hyperlinkGeographie, id, designationOfficial, stopType } = station;
    const { lat, lon } = hyperlinkGeographie;

    const isNonCommercial = stopType === 'non_commercial';

    return {
      geometry: {
        type: 'Point',
        coordinates: [lon, lat],
      },
      properties: {
        id: id,
        name: designationOfficial,
        isNonCommercial,
      },
    };
  }, []);

  return usePrepareGeojson(data, stationMapper);
};

export default useStopPositionData;
